import { render } from "./ResourceCard.vue?vue&type=template&id=56aa4e64&ts=true"
import script from "./ResourceCard.vue?vue&type=script&lang=ts"
export * from "./ResourceCard.vue?vue&type=script&lang=ts"

import "./ResourceCard.vue?vue&type=style&index=0&id=56aa4e64&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__